/**
 * ZIP'ni brauzerda ochishda parol ishlatish-ishlatmaslikni bitta joydan
 * boshqarish uchun. Backend endi javob varaqalari ZIP'ini parollab
 * qaytaryapti (ichidagi "ProtectedArchive.zip" nomli shifrlangan entry —
 * uni {@link ZipExplorerService} avtomatik ochadi/unwrap qiladi).
 */
export const ZIP_PASSWORD_CONFIG = {
  enabled: true,
  getPassword: (): string => 'Qwerty123@!',
};
